import { MutableRefObject, useImperativeHandle, useState } from "react";
import styled from "styled-components";
import { CalendarConnection } from "@lifeat/shared/data-models/user/integrations/IntegrationsDataEntity";
import LifeAtButton from "@common/LifeAtButton/LifeAtButton";
import LifeAtModal from "@common/LifeAtModal/LifeAtModal";
import SettingsGearStrokeSvg from "@icons/SettingsGearIconStroke.svg";
import { CalendarManagement } from "./CalendarManagement";

const SettingGearIcon = styled(SettingsGearStrokeSvg)`
    fill: ${(props) => props.theme.iconColor};
`;

const SettingsButton = styled(LifeAtButton)`
    width: auto;
    padding: unset;
    min-height: unset;
`;

export type CalendarSettingsModalHandle = {
    open: () => void;
};

interface CalendarSettingsModalProps {
    onCalendarConnectionRemove: (connection: CalendarConnection) => void;
    imperativeRef?: MutableRefObject<CalendarSettingsModalHandle>;
    className?: string;
}
function CalendarSettingsModal(props: CalendarSettingsModalProps) {
    const [isOpen, setIsOpen] = useState(false);

    useImperativeHandle(props.imperativeRef, () => ({
        open: () => setIsOpen(true),
    }));

    return (
        <>
            <span className={props.className}>
                <SettingsButton
                    key={`toggle-calendar-settings-modal-btn`}
                    isLink={false}
                    icon={<SettingGearIcon />}
                    handleClick={() => setIsOpen(!isOpen)}
                />

                <LifeAtModal
                    key={`calendar-settings-modal`}
                    isOpen={isOpen}
                    closeModal={() => setIsOpen(false)}
                    title={"Calendar Settings"}
                >
                    <CalendarManagement onCalendarConnectionRemove={props.onCalendarConnectionRemove} />
                </LifeAtModal>
            </span>
        </>
    );
}

export default CalendarSettingsModal;
